import './Skills.css';

// Components
import { Link } from "react-router-dom";

// skills contents
import { skills } from "../../assets/documents/config";

// Images
import whatICanDoImage from "../../assets/images/what-i-can-do.png";

const Skills = (props) => {
    return <section id="skills">
        <div>
            <h1>What I can do?</h1>
            <div className="skill-container">
                {
                    skills.map((skill) => {
                        return <div className="card" key={skill.index}>
                            <picture>
                                <img src={skill.iconSrc} alt={skill.title} />
                            </picture>
                            <h2>{skill.title}</h2>
                            <p>{skill.description}<br /><Link to={`/project/${skill.title}`} className="link-view-project">view projects.</Link></p>
                        </div>
                    })
                }
            </div>
        </div>

        <div>
            <img src={whatICanDoImage} className='whatICanDoImage' alt="what-I-Can-Do.png" />
        </div>

    </section>
}


export default Skills;
